export default __webpack_public_path__ + "sounds/e072cf8bebecdfb853d6221252319b6c.mp3";